import AvatarImage, { ROUNDED_PLACEHOLDER_IMAGE } from './AvatarImage';

export { ROUNDED_PLACEHOLDER_IMAGE };
export default AvatarImage;
